export default {
  description: function description(state) {
    return state.description;
  },
  products: function products(state) {
    return state.products;
  },
  tpl: function tpl(state) {
    return state.tpl;
  },
  productsCount: function productsCount(state) {
    return state.total;
  },
  productsPerPage: function productsPerPage(state) {
    return state.productsPerPage;
  },
  breadcrumb: function breadcrumb(state) {
    var _state$description;
    return ((_state$description = state.description) === null || _state$description === void 0 ? void 0 : _state$description.breadcrumb) || null;
  }
};